const BatchManagementRoutes = [
    {
      path: '/batch-management',
      name: 'batch-management',
      component: () => import('@/components/batchManagement/BatchManagement.vue'),
    },
  ];
  
  export default BatchManagementRoutes;
  